
    <div class="container gray-200">
        <section>
            <!--
            <div class="content-band max-w1440">
                <div class="flex-grid gap-20">
                    <div>
                        <eas-tile-swc menukey="menu1" iconstyle="fas fa-home" title="Role Management" description="Add and remove roles. Review existing roles. Manage role requests." (tileclick)="navigatRoleRequest()"></eas-tile-swc>
                        <eas-tile-swc menukey="menu1" iconstyle="fas fa-home" title="Contact Verification" description="Update or verify your email, phone number, and address." (tileclick)="navigatContactVerification()"></eas-tile-swc>
                        <eas-tile-swc menukey="menu1" iconstyle="fas fa-school" title="Organizations and Role Permissions" description="View organizations and role permissions." (tileclick)="navigateUrl()"></eas-tile-swc>
                    </div>
                </div>
            </div>
            -->
            <!-- This section of the html was copied from .\role-request\role-request-home\role-request-home.component.html - kevin.low 07/24/2025 -->
             <div>
                <ul class="tile-container fade">
                    <li>
                        <a href="javascript:void(0)" (click)="navigatRoleRequest()" 
                            class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                            <div class="tile--img">
                                <div class="img--position">
                                    <i class="fa-solid fa-file-invoice"></i>
                                </div>
                            </div>
                            <div class="tile--content">
                                <header class="header--tile">
                                    <div class="tile--title">Role Management</div>
                                </header>
                                <p class="p--tile">
                                    Add and remove roles. Review existing roles. Manage role requests.
                                </p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" (click)="navigatContactVerification()" 
                            class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                            <div class="tile--img">
                                <div class="img--position">
                                    <i class="fa-solid fa-user-plus"></i>
                                </div>
                            </div>
                            <div class="tile--content">
                                <header class="header--tile">
                                    <div class="tile--title">Contact Verification</div>
                                </header>
                                <p class="p--tile">
                                    Update or verify your email, phone number, and address.
                                </p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" (click)="navigateUrl()" class="a--tile tile--lrg white hover--shadow"
                            style="border-radius:calc(8px)">
                            <div class="tile--img">
                                <div class="img--position">
                                    <i class="fa-solid fa-user-minus"></i>
                                </div>
                            </div>
                            <div class="tile--content">
                                <header class="header--tile">
                                    <div class="tile--title">Organizations and Role Permissions</div>
                                </header>
                                <p class="p--tile">
                                    View organizations and role permissions.
                                </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </div>